"use strict";
/*
 * TrackingEvent is the type of the payload of a
 * custom event coming from a Studio Creative
 *
 * eC: Event Category
 * eA: Event Action
 * eL: Event Label
 * eV: Event Value
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=studio-creative.types.js.map